import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { Link } from "react-router-dom";
import { Login } from "@mui/icons-material";
import Box from '@mui/material/Box';

const Header: React.FC = () => {
    return (
        <AppBar position="fixed" sx={{ paddingRight: '4rem', backgroundColor: '#000000' }}>
            <Toolbar disableGutters>
                <img
                    src={"/images/Moose-cropped.svg"}
                    style={{ height: '50px' }}
                    alt="Moosebit Logo"
                />
                <Typography
                    noWrap
                    component={Link}
                    to={"/"}
                    color="#1bd45a"
                    sx={{
                        mr: 3,
                        display: { xs: 'flex', md: 'flex' },
                        fontWeight: 700,
                        fontSize: { xs: '10px', sm: '12px', md: '14px' },
                        letterSpacing: '.3rem',
                        textDecoration: 'none',
                    }}
                >
                    MOOSEBIT
                </Typography>
                <Box sx={{ flexGrow: 1 }} />
                <Link to="https://www.moosemedusanew.com/Login" target="_blank" style={{ textDecoration: 'none', color: 'inherit' }}>
                    <Button size="small" variant="text" endIcon={<Login />} sx={{ color: '#ffffff', paddingLeft: "2rem" }}>
                        Login
                    </Button>
                </Link>
            </Toolbar>
        </AppBar>
    );
};

export default Header;
